export default __webpack_public_path__ + "assets/icons/contact-whatapp.b49243c8.svg";